import { render, staticRenderFns } from "./Tracker.vue?vue&type=template&id=0c70b730&scoped=true"
import script from "./Tracker.vue?vue&type=script&lang=js"
export * from "./Tracker.vue?vue&type=script&lang=js"
import style0 from "./Tracker.vue?vue&type=style&index=0&id=0c70b730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c70b730",
  null
  
)

export default component.exports